import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { tableMonth } from '../helpers';

const ReportsTable = ({ data }) => {
  const rows = Array.from({ length: 31 }, (_, i) => (i + 1).toString().padStart(2, '0'));

  return (
    <Table className="mb-24 reports-table">
      <thead>
        <tr>
          <th> &nbsp; </th>
          {tableMonth?.map((col) => (
            <th key={col.key}>{col.label}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {rows?.map((row, index) => (
          <tr key={row}>
            <td>{index + 1}</td>
            {tableMonth?.map((col) => (
              <td key={col.key}>{data?.grid?.[row]?.[col.key]}</td>
            ))}
          </tr>
        ))}
        <tr>
          <td>
            <b>Total</b>
          </td>
          {tableMonth?.map((col) => (
            <td key={col.key}>
              <b>{data?.totals?.[col.key]}</b>
            </td>
          ))}
        </tr>
      </tbody>
    </Table>
  );
};

ReportsTable.propTypes = {
  data: PropTypes.object,
};

export default ReportsTable;
